module.exports = __webpack_public_path__ + "static/media/donut.c960af4e.png";